import React from 'react';
import ViewYourMasterComponentStyle from './style';

interface YourMasterProps {
    atAGlance: any;
}

const YourMasterComponent: React.FC<YourMasterProps> = ({ atAGlance }) => {
    const { itineraryComments = [], tourName } = atAGlance || {};
    const result = tourName?.split(' - ')[0];

    return (
        <div>
            {itineraryComments.length > 0 && (
                <ViewYourMasterComponentStyle className="card">
                    <div className="header">Your {result} At A Glance</div>
                    <div className="body">
                        {itineraryComments?.map((item: any, index: any) => (
                            <div className="titleDetailAtAGlance" key={index}>
                                {item}
                            </div>
                        ))}
                    </div>
                </ViewYourMasterComponentStyle>
            )}
        </div>
    );
};

export default YourMasterComponent;
